import React from "react";
import { DashboardPageShell } from "../components/dashboardUi";

/** Gradient hero + spaced content panels — shared layout for dashboard section pages */
const DashboardSectionShell = ({ eyebrow, title, description, icon, badges, tabs, children }) => (
  <DashboardPageShell
    eyebrow={eyebrow}
    title={title}
    description={description}
    icon={icon}
    badges={badges}
    tabs={tabs}
  >
    {children}
  </DashboardPageShell>
);

export default DashboardSectionShell;
